module.exports = __webpack_public_path__ + "img/DAY2-1.49481915.jpg";